var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.78,
    height: 34.874,
    viewBox: "0 0 31.78 34.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2eb77d;}.b{fill:#20253a;}.c{fill:#fdfefe;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(648 -4434)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-648 4434)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.453,218.981a9.263,9.263,0,0,1,4.9-8.2h0a4.056,4.056,0,0,1,.6-.281,10.883,10.883,0,0,0-4.62-1H31.283a11.137,11.137,0,0,0-11.169,11.129v2.812a1.184,1.184,0,0,0,1.205,1.205H35.381a6.828,6.828,0,0,1-.4-.562A9.07,9.07,0,0,1,33.453,218.981Z",
    transform: "translate(-20.114 -193.388)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M96.47,14.785a7.423,7.423,0,0,0,5.223-2.17,7.372,7.372,0,0,0,0-10.446,7.372,7.372,0,0,0-10.446,0,7.5,7.5,0,0,0-2.17,5.223A7.425,7.425,0,0,0,96.47,14.785Z",
    transform: "translate(-83.775 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M200.236,211.592a9.518,9.518,0,0,0-3.777.8c-.2.08-.4.2-.6.281h0a9.357,9.357,0,0,0-4.9,8.2,9.07,9.07,0,0,0,1.527,5.1,4.877,4.877,0,0,0,.4.562,9.308,9.308,0,1,0,7.352-14.946Z",
    transform: "translate(-177.817 -195.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M258.35,281.639v-2.129h2.129a1.205,1.205,0,1,0,0-2.411H258.35v-2.129a1.205,1.205,0,0,0-2.411,0V277.1H253.81a1.205,1.205,0,1,0,0,2.411h2.129v2.129a1.205,1.205,0,1,0,2.411,0Z",
    transform: "translate(-234.726 -252.711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/addUser.d0aa9cf8de11671a8448f379fd887706.svg";
export { ForwardRef as ReactComponent };